import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from '@hunchads/header-config';
import type { Account } from '@hunchads/header-config';
import { AccountService, CatalogsHubService, get, set } from '@shared';

window.UIkit = UIkit;

import UIkit from 'uikit';
declare global {
  interface Window {
    UIkit: any;
    user: any;
  }
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'automation-plan';
  private hub: CatalogsHubService = inject(CatalogsHubService);
  private accountService: AccountService = inject(AccountService);

  ngOnInit(): void {
    this.hub.listenHubSubscriptions();
    this.initializeHeader();
  }

  private async initializeHeader(): Promise<void> {
    await new Promise((resolve) => setTimeout(resolve, 0));

    const container = document.getElementById('header-container');
    if (!container || container.children.length > 0) return;

    await Header.create({
      container,
      accounts: get('accounts') || [],
      selectedUser: get('user') || undefined,
      defaultLink: 'automationPlans',
      onAccountChange: (account: Account) => this.handleAccountChange(account),
      onLogout: () => this.handleLogout(),
    });
  }

  private handleAccountChange(account: Account): void {
    const accountId = account?.id ?? (account as unknown as number);
    set('user', { ...get('user'), accountId });
    this.accountService.accountChanged.next(accountId);
    if (window.location.pathname !== '/') {
      window.location.href = get('hunchAutomationPlansUrl');
    }
  }

  private handleLogout(): void {
    const hunchAppUrl = get('hunchAppUrl');
    if (hunchAppUrl) {
      window.location.assign(hunchAppUrl);
    }
  }
}
